<template>
  <a-card v-if="policies.length" normalize-card-body closable start-closed>
    <span slot="header" v-t="label" />
    <ul
      slot="body"
      class="password-policies-list list-group list-group-flush ps-0"
    >
      <li
        v-for="(policy, index) in policies"
        :key="index"
        class="list-group-item"
        v-text="translateByPolicy(policy)"
      />
    </ul>
  </a-card>
</template>

<script>
import Card from "+/components/card/Card";

export default {
  components: {
    "a-card": Card
  },
  props: {
    label: {
      type: String,
      default: "Components.PasswordPolicies.Label"
    },
    policies: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    translateByPolicy({ type, value }) {
      if (typeof type !== "string") return "";
      if (type === "REGEX_PATTERN") {
        return this.$t(`Security.PasswordValidation.RegexPattern`, {
          0: value
        });
      }
      if (type === "SPECIAL_CHARS") {
        return this.$t(`Security.PasswordValidation.SpecialChars`, {
          0: value
        });
      }
      if (type === "NOTUSERNAME") {
        return this.$t("Security.PasswordValidation.NotUserName");
      }
      if (type === "NOTRECENTLYUSED") {
        return this.$t("Security.PasswordValidation.NOTRECENTLYUSED", {
          0: value
        });
      }
      const key = `${type.charAt(0).toUpperCase()}${type
        .slice(1)
        .toLowerCase()}`;
      return this.$t(`Security.PasswordValidation.${key}`, { 0: value });
    }
  }
};
</script>
